import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, effect, inject, model, ModelSignal, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TrackData } from '@shared/interfacres/track';
import { Playlist } from '@shared/interfacres/playlist';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import {
  MatChipGrid,
  MatChipInput,
  MatChipRemove,
  MatChipRow,
} from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-add-to-playlist-dialog',
  templateUrl: 'add-to-playlist-dialog.html',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,

    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,

    MatIcon,
    MatChipGrid,
    MatChipInput,
    MatChipRemove,
    MatChipRow,
  ],

  styleUrl: 'add-to-playlist-dialog.scss'
})
export class AddToPlaylistDialog implements OnInit {

  readonly dialogRef = inject(MatDialogRef<AddToPlaylistDialog>);
  readonly data = inject<{
    track: TrackData,
    playlists: Playlist[]
  }>(MAT_DIALOG_DATA);

  readonly currentPlaylist: ModelSignal<{id: 0, name: ''}> = model({id: 0, name: ''});
  readonly playlists: ModelSignal<Playlist[]> = model([] as Playlist[]);

  availableOptions: Playlist[] = [];


  constructor() {
    effect(() => {
      const alreadySelected = this.playlists();
      this.availableOptions = this.data.playlists.filter((option: Playlist) => {
        return alreadySelected.findIndex((selectedGenre: Playlist) => selectedGenre.id === option.id) === -1;
      });
    });

    effect(() => {
      const query = this.currentPlaylist();
      const alreadySelected = this.playlists();
      const name: string = typeof query === 'string' ? query : query?.name;
      this.availableOptions = name ?
      //   this.data.playlists.filter((option: Playlist) => option.name.toLowerCase().includes(name.toLowerCase())) :
      //   this.data.playlists;
      this.data.playlists.filter((option: Playlist) => {
        return option.name.toLowerCase().includes(name.toLowerCase()) &&
          alreadySelected.findIndex((selectedGenre: Playlist) => selectedGenre.id === option.id) === -1;
        }) :
        this.data.playlists.filter((option: Playlist) => {
           return alreadySelected.findIndex((selectedGenre: Playlist) => selectedGenre.id === option.id) === -1;
      });
    });
  }

  ngOnInit() {
    const trackInPlaylists = this.data.playlists.filter((item: Playlist) => {
      const isInPlaylist: number = item.tracks?.findIndex((track: TrackData) => {
        return track.id === this.data.track.id
      }) as number;
      return isInPlaylist > -1;
    })
    this.playlists.set(trackInPlaylists);
    this.availableOptions = this.data.playlists;
  }

  remove(itemToRemove: Playlist): void {
    const updated = this.playlists()?.filter((item: Playlist) => {
      return item.id !== itemToRemove.id;
    });
    this.playlists.set(updated as Playlist[]);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.playlists.set(this.playlists().concat(event.option.value as Playlist));
    this.currentPlaylist.set({id: 0, name: ''});
    event.option.deselect();
  }

  displayStateName(state: {name: string}): string {
    return state ? state.name : '';
  }


  save(): void {
    this.dialogRef.close(this.playlists());
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
